import { extractTranslationTokens } from "@redotech/i18n-backend/translation-safety";

const LINK_TEXT_MOVED = "link text moved out of link";

interface Link {
  openTag: string;
  hasLetters: boolean;
}

function hasLetters(text: string): boolean {
  return /\p{L}/u.test(text.replace(/&[#\w]+;/g, ""));
}

/** `<a>` elements in order; text excludes tags and Liquid output. */
function links(value: string): Link[] {
  const result: Link[] = [];
  let open: { tag: string; text: string } | undefined;
  let cursor = 0;
  for (const token of extractTranslationTokens(value)) {
    if (open) {
      open.text += value.slice(cursor, token.start);
    }
    cursor = token.end;
    if (token.kind !== "html") {
      continue;
    }
    if (/^<a[\s>]/i.test(token.value)) {
      open = { tag: token.value, text: "" };
    } else if (open && /^<\/a\s*>$/i.test(token.value)) {
      result.push({ openTag: open.tag, hasLetters: hasLetters(open.text) });
      open = undefined;
    }
  }
  return result;
}

/**
 * Rejects translations that empty a link of words, such as leaving only the
 * period linked. Both strings must parse.
 */
export function getLinkTextError(
  source: string,
  translation: string,
): typeof LINK_TEXT_MOVED | undefined {
  const translationLinks = links(translation);
  const moved = links(source).some((link, i) => {
    const translated = translationLinks[i];
    return (
      link.hasLetters &&
      (translated?.openTag !== link.openTag || !translated.hasLetters)
    );
  });
  return moved ? LINK_TEXT_MOVED : undefined;
}
